module.exports = __webpack_public_path__ + "img/309a488f82c98ef30b5d08d1d771627f.png";